import { useState } from "react";
import { hotRank, searchHot } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function HotPanel() {
  const [active, setActive] = useState<number | null>(null);
  const [tab, setTab] = useState(0);
  const tabs = ["24 小时热榜", "实时热度"];

  return (
    <aside className="flex flex-col gap-8">
      {/* hot rank */}
      <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h2 className="flex items-center gap-2 whitespace-nowrap font-heading text-lg font-bold text-foreground-950">
            <i className="ri-fire-fill text-primary-500" />
            全网热议榜
          </h2>
          <div className="flex items-center gap-1 rounded-full bg-background-200/70 p-1">
            {tabs.map((t, i) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(i)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
                  tab === i
                    ? "bg-primary-500 font-medium text-background-50"
                    : "text-foreground-500 hover:text-primary-600"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-4 flex flex-col gap-1">
          {hotRank.slice(0, 8).map((h, i) => {
            const top3 = i < 3;
            const open = active === i;
            return (
              <li key={h.rank} className="border-b border-dashed border-background-200 last:border-0">
                <button
                  type="button"
                  onClick={() => setActive(open ? null : i)}
                  className="flex w-full cursor-pointer items-center gap-3 py-2.5 text-left"
                >
                  <span
                    className={`w-6 shrink-0 text-center font-display text-xl ${
                      top3 ? "text-primary-600" : "text-foreground-300"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <span className="flex-1 text-sm leading-snug text-foreground-800">
                    {h.title}
                  </span>
                  <span className="flex shrink-0 items-center gap-1 text-[11px] text-accent-700">
                    <i className="ri-flashlight-fill" />
                    {h.heat}
                  </span>
                </button>
              </li>
            );
          })}
        </ol>

        <a
          href="#"
          onClick={(e) => e.preventDefault()}
          className="mt-2 flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap py-1 text-xs text-primary-600 hover:text-primary-700"
        >
          完整热议榜 TOP 50
          <i className="ri-arrow-right-line" />
        </a>
      </div>

      {/* hot topics chips */}
      <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-hashtag" />
          热议话题
        </h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {searchHot.map((s) => (
            <button
              key={s}
              type="button"
              className="cursor-pointer whitespace-nowrap rounded-md bg-background-200/70 px-2.5 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-accent-100 hover:text-accent-900"
            >
              # {s}
            </button>
          ))}
        </div>
      </div>

      {/* small note */}
      <div className="rounded-lg border border-accent-200 bg-accent-100/60 p-4">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
            <i className="ri-megaphone-line" />
          </span>
          <div>
            <h4 className="whitespace-nowrap font-heading text-sm font-bold text-foreground-900">编辑部提醒</h4>
            <p className="mt-1 text-xs leading-relaxed text-foreground-600">
              部分线索仍在核实中，网传内容请以官方通报为准。认准看黑料今日曝光入口，不错过每一次跟进。
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
}